import Api from './Api'

export default {
    send(mailOptions) {
        return Api().post(`/send/`, mailOptions);
    }
}